import { Box, Grid } from "@mui/material";
import { searchStoreActions } from "features/searchStore/saga/searchStoreSlice";
import { useRef, useEffect } from "react";
import { useAppDispatch } from "redux/hooks";
import { useOnScreen } from "utils/commonHooks";
import GeneralInfomationCart from "../components/GeneralInfomationCard";
import SideStatusCard from "../components/SideStatusCard";
import {
  HeaderSection,
  BannerSection,
  SearchByArea,
  SearchByGenre,
  SearchByCondition,
  FooterSection,
  SearchByScenario,
} from "../sections";
import { HeroImageSection } from "../sections/landscape/HeroImageSection";

export function LandscapeView() {
  const dispatch = useAppDispatch();
  const bannerRef = useRef(null);
  const bannerOnScreen = useOnScreen(bannerRef);

  useEffect(() => {
    dispatch(searchStoreActions.resetSearchFilter());
  }, [dispatch]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      position="relative"
      // maxWidth="1000px"
    >
      <HeaderSection shouldSticky={!bannerOnScreen} />

      <Box ref={bannerRef}>
        {/* <BannerSection /> */}
        <HeroImageSection />
      </Box>

      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        px={5}
        py={5}
        bgcolor="white"
      >
        <Box maxWidth="1000px">
          <SearchByArea />
          <SearchByGenre />

          <SearchByScenario />

          <SearchByCondition />
        </Box>
      </Box>
      <FooterSection />
    </Box>
  );
}
